export const MARINE_INPUT_PLACEHOLDER_VALUE = '<placeholder>'
